import React from 'react';
import { Instagram, Facebook, Heart, Eye } from 'lucide-react';
import { contactInfo } from '../data/mock';

const SocialMediaSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-green-600 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Follow Our Work on Social Media
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            See our latest projects, before & after transformations, and get daily inspiration for your next building project
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Instagram Card */}
          {contactInfo.socialMedia?.instagram && (
            <a
              href={contactInfo.socialMedia.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-purple-600 to-pink-500 rounded-2xl p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                <div className="flex items-center justify-center mb-6">
                  <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
                    <Instagram className="w-12 h-12 text-purple-600" />
                  </div>
                </div>
                
                <h3 className="text-3xl font-bold text-center mb-4">Instagram</h3>
                <p className="text-center text-purple-100 mb-6">
                  Daily updates • Project photos • Behind the scenes
                </p>

                <div className="flex items-center justify-center space-x-6 mb-6">
                  <div className="flex items-center space-x-2">
                    <Eye className="w-5 h-5" />
                    <span className="font-semibold">View Projects</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Heart className="w-5 h-5" />
                    <span className="font-semibold">Like & Follow</span>
                  </div>
                </div>

                <div className="text-center">
                  <div className="inline-block bg-white/20 backdrop-blur-sm hover:bg-white/30 px-8 py-3 rounded-full font-bold transition-colors">
                    Follow @msbuildingcontractors16
                  </div>
                </div>
              </div>
            </a>
          )}

          {/* Facebook Card */}
          {contactInfo.socialMedia?.facebook && (
            <a
              href={contactInfo.socialMedia.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                <div className="flex items-center justify-center mb-6">
                  <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
                    <Facebook className="w-12 h-12 text-blue-600" />
                  </div>
                </div>
                
                <h3 className="text-3xl font-bold text-center mb-4">Facebook</h3>
                <p className="text-center text-blue-100 mb-6">
                  Customer reviews • Project updates • Special offers
                </p>

                <div className="flex items-center justify-center space-x-6 mb-6">
                  <div className="flex items-center space-x-2">
                    <Eye className="w-5 h-5" />
                    <span className="font-semibold">See Our Work</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Heart className="w-5 h-5" />
                    <span className="font-semibold">Like Our Page</span>
                  </div>
                </div>

                <div className="text-center">
                  <div className="inline-block bg-white/20 backdrop-blur-sm hover:bg-white/30 px-8 py-3 rounded-full font-bold transition-colors">
                    Like MS Building Contractors
                  </div>
                </div>
              </div>
            </a>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-2xl text-gray-300 mb-2">
            Join our growing community!
          </p>
          <p className="text-green-400 font-semibold text-lg">
            Get inspired • Stay updated • Connect with us
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;
